import axios from 'axios';
import type { AxiosResponse } from 'axios';
import {
    DC_FORM_SENDER_APPLICATIONS_CODES_RESEND,
    DC_FORM_SENDER_APPLICATIONS_CODES_VERIFY,
    DC_FORM_SENDER_APPLICATIONS_CODES_DELIVERY_VERIFY,
    DC_FORM_SENDER_APPLICATIONS_CODES_DELIVERY_RESEND,
} from '@alfa-bank/site-dc-env-config';

import type { ISmsResponse, IFinishResponse } from '../models/api';

export const verifySmsApi = ({
    appId,
    code,
    uuid,
}: {
    appId: string;
    code: string;
    uuid: string;
}): Promise<AxiosResponse<ISmsResponse>> => {
    const config = {
        headers: {
            BusinessUid: uuid,
            // eslint-disable-next-line sonarjs/no-duplicate-string
            'Content-Type': 'application/json',
        },
    };

    return axios.post<ISmsResponse>(
        DC_FORM_SENDER_APPLICATIONS_CODES_VERIFY({ appId }),
        { code },
        config
    );
};

export const verifySmsFinishApi = ({
    appId,
    code,
    uuid,
}: {
    appId: string;
    code: string;
    uuid: string;
}) => {
    const config = {
        headers: {
            BusinessUid: uuid,
            'Content-Type': 'application/json',
        },
    };

    return axios.post<IFinishResponse>(
        DC_FORM_SENDER_APPLICATIONS_CODES_DELIVERY_VERIFY({ appId }),
        { code },
        config
    );
};

export const requestSmsCodeApi = ({
    appId,
    uuid,
}: {
    appId: string;
    uuid: string;
}): Promise<AxiosResponse<ISmsResponse>> => {
    const config = {
        headers: {
            BusinessUid: uuid,
            'Content-Type': 'application/json',
        },
    };

    return axios.post<ISmsResponse>(
        DC_FORM_SENDER_APPLICATIONS_CODES_RESEND({ appId }),
        undefined,
        config
    );
};

export const deliveryResendSmsCodeApi = ({
    appId,
    uuid,
}: {
    appId: string;
    uuid: string;
}): Promise<AxiosResponse<ISmsResponse>> => {
    const config = {
        headers: {
            BusinessUid: uuid,
            'Content-Type': 'application/json',
        },
    };

    return axios.post<ISmsResponse>(
        DC_FORM_SENDER_APPLICATIONS_CODES_DELIVERY_RESEND({ appId }),
        undefined,
        config
    );
};
